import React, { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import useDebounce from '../../../../../utils/hooks/useDebounce';
import EdgePageFrame from '../EdgePageFrame';


const EdgeContact: React.FC = () => {
    const [showCopied, setShowCopied] = useState(false);
    
    useDebounce(() => {
        setShowCopied(false);
    }, 2000, [showCopied])

    const handleOnClick = () => {
        navigator.clipboard.writeText('services@thgaming.gg');
        setShowCopied(true);
    }

    return (
        <EdgePageFrame key='contact'>
            <div className='w-full flex justify-center items-center py-4'>
                <div className='flex flex-col justify-center items-center px-6 py-4 bg-white rounded-md bg-opacity-5 gap-y-2'>
                    <div className='text-4xl font-semibold text-teko italic text-neutral-900'>Contact</div>
                    <p className='text-center text-2xl text-neutral-800'>Grow your business with Artisan's Edge merchandise. Shoot us a message to us now to schedule a meeting (we'll come to YOU!)</p>
                    {/* <p className='text-red-950 text-3xl'>XXX - XX - XXX</p> */}
                    <div
                        className='relative p-2'
                        onClick={handleOnClick}
                    >
                        <p
                            className='text-pink-900 text-teko italic text-3xl font-semibold hover:cursor-pointer px-2 py-1 rounded-md bg-black bg-opacity-10 shadow-2xl'
                        >services@thgaming.gg</p>
                        <AnimatePresence>
                            {showCopied &&
                                <motion.div
                                    key={Math.random()}
                                    initial={{ y: 30, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    exit={{ y: -30, opacity: 0 }}
                                    className='absolute top-0 left-0 size-full rounded-sm bg-pink-800 bg-opacity-50 text-white text-3xl text-center text-teko px-4 pt-1 pb-2'
                                >
                                    Copied!
                                </motion.div>}
                        </AnimatePresence>
                    </div>
                </div>
            </div>
        </EdgePageFrame>
    )
}

export default EdgeContact;